

/**
 * @name MoreController
 * @param {unknown} $rootScope Unknown
 * @param {object} Auth Our global auth service
 * @param {object} Session The service that holds session data
 * @param {unknown} $state Unknown
 * @param {unknown} DEFAULT_STATES The constant for default states per role
 * @param {unknown} SWITCH_MESSAGE The switch messages constant
 * @param {unknown} $cookies Angular $cookies service
 */
function MoreController(
  $rootScope,
  Auth,
  Session,
  $state,
  DEFAULT_STATES,
  SWITCH_MESSAGE,
  $cookies
) {
  let vm = this;

  vm.$onInit = function() {
    vm.logout = logout;
    vm.changeState = changeState;
    vm.switchToBuying = switchToBuying;
    vm.session = Session;
  };

  /**
   * @name changeState
   * @description Function to change states (buy/selling) and the user role
   * associated with the state
   * @param {object} activeState The selected state
   */
  function changeState(activeState) {
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(activeState);
    $cookies.putObject('inkfinder', activeState);
    if (activeState.role === 'operator') {
      $state.go(DEFAULT_STATES.operator);
    } else {
      $state.go(DEFAULT_STATES.artist);
    }
  }

  /**
   * @name switchToBuying
   * @description Function to move the user to the collector's dashboard
   */
  function switchToBuying() {
    const state = {
      mode: 'buying',
      role: 'collector',
      switchMessage: SWITCH_MESSAGE.buying,
      id: 1
    };
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(state);
    $cookies.putObject('inkfinder', state);
    $state.go(DEFAULT_STATES.buying);
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    Auth.logout();
  }
}

angular
  .module('inkfinder')
  .controller('MoreController', MoreController);



// WEBPACK FOOTER //
// ./common/more/more.controller.js